import {
  Flex,
  Spin,
  Table,
} from 'antd'
import React, { useState } from 'react'
import useAsync from 'react-use/lib/useAsync'

import { ReportsPageProps } from '@/components/feature/analytics/hooks/use-report-search'
import { FeatureKey } from '@/constants/feature-key'
import { readChatterOverviewStatistics } from '@/redux/chatter-reports-actions'
import {
  useAppDispatch,
  useAppSelector,
} from '@/redux/utils'
import {
  formatPercentage,
  formatDurationToH_M_S,
} from '@/utils/formatter'

import { useChatterOverviewStatisticsColumns } from '../common/chatter-overview-statistics-columns'
import SectionTitle from '../section-title'
import StatisticNumber from '../statistic-number'

export default function ChatterOverviewStatistics({ searchValues }: ReportsPageProps) {
  const { chatterOverviewStatistics } = useAppSelector(state => state.chatterReports)
  const dispatch = useAppDispatch()
  const [loading, setLoading] = useState(false)

  useAsync(async () => {
    setLoading(true)
    try {
      await dispatch(readChatterOverviewStatistics({
        ...searchValues,
        permissionKey: FeatureKey.ChatterReportsOverview,
      })).unwrap()
    } catch (e) {
      console.log(e)
    }
    setLoading(false)
  }, [dispatch, searchValues])

  const columns = useChatterOverviewStatisticsColumns()

  return (
    <>
      <Spin spinning={loading}>
        <Flex vertical gap={16}>
          <SectionTitle title="Chatting statistics" />
          <Flex gap={16}>
            <StatisticNumber
              title="Total chatter sales (🌟)"
              value={chatterOverviewStatistics?.total || 0}
              tooltip="Total sales based on your team's Chatter settings during this period"
              precision={0}
              prefix="🌟"
            />
            <StatisticNumber
              title="Unlock rate"
              value={formatPercentage({ symbol: '' })(chatterOverviewStatistics?.unlockRate)}
              precision={0}
              tooltip="The average unlock rate of your team"
              suffix="%"
            />
            <StatisticNumber
              title="Average reply time"
              value={formatDurationToH_M_S()(chatterOverviewStatistics?.replyTime)}
              precision={0}
              tooltip="The average reply time of your team"
            />
            <StatisticNumber
              title="Scheduled hours"
              value={chatterOverviewStatistics?.scheduledHours || 0}
              precision={0}
              suffix="h"
              tooltip="Total hours worked by your team during this period"
            />
          </Flex>
          <Flex vertical>
            <Table
              columns={columns}
              rowKey="id"
              scroll={{ x: 1500 }}
              dataSource={chatterOverviewStatistics?.employees || []}
              pagination={false}
            />
          </Flex>
        </Flex>
      </Spin>
    </>
  )
}
